<!--登录-->
<template>
  <div  class="root-container">

<!--    查询条件区域-->
    <div class="search-content-area">
      <el-row>
        <el-col :span="6" class="class-input-search">
          <el-row>
            <el-col :span="10"><div style="margin-top: 10px;margin-left: 30px">日志分类:</div></el-col>
            <el-select v-model="queryParam.logtype" placeholder="请选择">
              <el-option
                v-for="item in logTypeList"
                :key="item.type"
                :label="item.des"
                :value="item.type">
              </el-option>
            </el-select>
          </el-row>
        </el-col>
        <el-col :span="6" class="class-input-search">
        </el-col>
      </el-row>

    </div>


<!--    查询按钮区域-->
    <div class="search-button-area">
      <el-button type="primary" style="margin-top: 5px" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
    </div>

<!--    查询结果区域-->

    <!--约课-->
    <div v-show="getRefreshTimer(7).show" class="search-result-area">
      <user-book-lesson-log :key="getRefreshTimer(7).refreshTimer" v-bind:detail="logList"></user-book-lesson-log>
    </div>

    <!--购买卡-->
    <div v-show="getRefreshTimer(3).show"  class="search-result-area">
      <user-buy-card-log  :key="getRefreshTimer(3).refreshTimer" v-bind:detail="logList"></user-buy-card-log>
    </div>

    <!--家长签到-->
    <div v-show="getRefreshTimer(8).show"  class="search-result-area">
      <user-sing-in-log  :key="getRefreshTimer(8).refreshTimer" v-bind:detail="logList"></user-sing-in-log>
    </div>

    <!--店铺课程卡-->
    <div v-show="getRefreshTimer(12).show"  class="search-result-area">
      <store-lesson-card-log  :key="getRefreshTimer(12).refreshTimer" v-bind:detail="logList"></store-lesson-card-log>
    </div>

    <!--续课时-->
    <div v-show="getRefreshTimer(6).show"  class="search-result-area">
      <renewal-card-lesson-log  :key="getRefreshTimer(6).refreshTimer" v-bind:detail="logList"></renewal-card-lesson-log>
    </div>


    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      background
      :current-page="queryParam.pageNum"
      :page-sizes="queryParam.pageSizes"
      :page-size="queryParam.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="queryParam.totalPage">
    </el-pagination>

  </div>
</template>

<style scoped>

  .root-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .search-content-area{
    width: 90%;
    height: 200px;
    /*设置边框颜色和圆角*/
    border-radius: 4px;
    border-top: 2px solid rgb(227,227,227);
    border-bottom: 1px solid rgb(227,227,227);
    border-left: 1px solid rgb(227,227,227);
    border-right: 1px solid rgb(227,227,227);
    /*border:1px solid rgb(227,227,227);*/
  }

  .search-button-area{
    width: 90%;
    height: 50px;
    /*设置边框颜色和圆角*/
    border-radius: 4px;
    border-bottom: 2px solid rgb(227,227,227);
    border-left: 1px solid rgb(227,227,227);
    border-right: 1px solid rgb(227,227,227);
    /*border:1px solid rgb(227,227,227);*/
  }

  .search-result-area{
    width: 100%;

    margin-top: 50px;
    /*设置边框颜色和圆角*/
    border-top: 2px solid rgb(227,227,227);
    border-bottom: 1px solid rgb(227,227,227);
    border-left: 1px solid rgb(227,227,227);
    border-right: 1px solid rgb(227,227,227);
  }

  .class-input-search{
    margin-top: 20px;
   font-weight: 700;
  }


</style>

<script>
  import UserBookLessonLog from "./components/UserBookLessonLog";
  import {qLserverLog, qlStoreLogType} from "../../api/serverLog";
  import globaldata from "../../utils/globaldata";
  import commonUtils from "../../utils/commonUtils";
  import logUtils from "../../utils/logUtils";
  import UserBuyCardLog from "./components/UserBuyCardLog";
  import StoreLessonCardLog from "./components/StoreLessonCardLog";
  import UserSingInLog from "./components/UserSingInLog";
  import RenewalCardLessonLog from "./components/RenewalCardLessonLog";

  export default {
    components: {RenewalCardLessonLog, UserSingInLog, StoreLessonCardLog, UserBookLessonLog,UserBuyCardLog},
    data() {
      return {
        timer:"",
        logList:[

        ],

        queryParam:{
          logtype:"",
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },
        logTypeList:[

        ]
      }
    },

    created(){
      this.fitchList();
      this.getLogType();
    },
    methods: {

      fitchList(){
        let param ={
          storeFrontId:globaldata.getAdminStore().storeFrontId,
          pageNum:this.queryParam.pageNum,
          pageSize:this.queryParam.pageSize,
          type:this.queryParam.logtype
        }
        qLserverLog(param).then(response =>
        {
          this.logList = [];
          this.timer = new Date().getTime();
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.queryParam.totalPage = data.total;
          let list = data.list;
          this.setAllRefreshTimer(false);
          let LogType =   this.getLogDesByType(this.queryParam.logtype);
          for (let i = 0;i< list.length;++i){

            let content = logUtils.tranLogContent(list[i].content);
            let log = {
              LogType:LogType,
              id:list[i].id,
              time:list[i].time,
              content:content
            }
            this.logList.push(log);
          }
          this.setRefreshTimer(this.queryParam.logtype,true);
        })
      },
      getLogType(){
        let param = {
          storeFrontId: globaldata.getAdminStore().storeFrontId
        }
        qlStoreLogType(param).then(response =>
        {

          let list = response.data;
          if (commonUtils.isObjectNull(list)){
            return;
          }
          for (let i = 0;i<list.length;++i){
            let logItem =  logUtils.tranLogType(list[i]);
            let d = {
              refreshTimer:new Date().getTime(),
              type:logItem[0],
              des:logItem[1],
              show:false,
            }
            this.logTypeList.push(d);
          }

        })
      },

      getLogDesByType(type){
        for (let i = 0;i<this.logTypeList.length;++i){
          if (type == this.logTypeList[i].type){
            return this.logTypeList[i].des
          }
        }
      },
      setAllRefreshTimer(b){
        for (let i = 0;i<this.logTypeList.length;++i){
          this.logTypeList[i].refreshTimer = new Date().getTime();
          this.logTypeList[i].show = b;
        }
      },

      setRefreshTimer(type,b){
        for (let i = 0;i<this.logTypeList.length;++i){
          if (type == this.logTypeList[i].type){
            this.logTypeList[i].refreshTimer = new Date().getTime();
            this.logTypeList[i].show = b;
          }
        }
      },
      getRefreshTimer(type){
        for (let i = 0;i<this.logTypeList.length;++i){
          if (type == this.logTypeList[i].type){
            return this.logTypeList[i];
          }
        }
      },
      //点击查询按钮
      onBtnSearch(){
        this.fitchList();
      },

      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.fitchList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
      },
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/log/index.vue